import { Circle, MessageCircle } from "react-feather";

let menuText = localStorage.getItem("menu")
let menuJSON = JSON.parse(menuText)
let menuList = []

if(menuJSON != null){
    let menuCommunication = menuJSON.filter((item) => item.label == 'Komunikasi')

    if (menuCommunication[0] !== undefined) {
        if (menuCommunication[0].children != undefined || menuCommunication[0].children != null) {
            menuCommunication[0].children.map((item) => {
                if (item.label == 'Chat Personal') {
                    menuList.push({
                        id: "communication-personal",
                        title: "Chat Personal",
                        navLink: "/chat/personal",
                    })
                } else if (item.label == 'Chat Grup') {
                    menuList.push({
                        id: "communication-group",
                        title: "Chat Group",
                        navLink: "/chat/group",
                    })
                }
            })
        }
    }
}

const Communication = [{
    id: "comm",
    title: "Komunikasi",
    icon: <MessageCircle size={20} />,
    children: menuList
}]

export default Communication
